import { render, staticRenderFns } from "./v-card.vue?vue&type=template&id=9f98deee&scoped=true&"
import script from "./v-card.vue?vue&type=script&lang=ts&"
export * from "./v-card.vue?vue&type=script&lang=ts&"
import style0 from "./v-card.vue?vue&type=style&index=0&id=9f98deee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f98deee",
  null
  
)

export default component.exports